import { render } from "./generate.vue?vue&type=template&id=6635e7d0"
import script from "./generate.vue?vue&type=script&lang=js"
export * from "./generate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__